import React from 'react';
import { OrderedSet } from 'immutable';
import cd from 'debug';
import { get } from 'lodash';
import { Pagination } from '@gin-betting/match-list';

import SportEventRow, { StreamStub } from '../SportEventRow';
import { CustomVisibilitySensor } from '../CustomVisibilitySensor/CustomVisibilitySensor';

const debug = cd('app:match-list:components:ResultsMatchList');

interface Props {
    matchIds: OrderedSet<string>;
    isSmall: boolean;
    handleVisibilityChange?: Pagination.ReturnedPaginationProps['handleVisibilityChange'];
    visibilityInitRef?: Pagination.ReturnedPaginationProps['visibilityInitRef'];
}

class ResultsMatchList extends React.Component<Props> {
    getMatchIds = () => this.props.matchIds;

    render() {
        debug('render', this.props);

        const {
            matchIds,
            handleVisibilityChange,
            visibilityInitRef,
        } = this.props;

        const sportEventRows: JSX.Element[] = [];

        let prevMatchId: string | undefined;

        matchIds.delete('visibility1').forEach(matchId => {
            const component = matchId.match(/visibility/) ? (
                <CustomVisibilitySensor
                    key={matchId}
                    visibilityChange={handleVisibilityChange}
                    page={+get(matchId.match(/\d+$/), [0], 0)}
                    visibilityInitRef={visibilityInitRef}
                />
            ) : (
                <SportEventRow
                    key={matchId}
                    matchId={matchId}
                    prevMatchId={prevMatchId}
                    isResultPage={true}
                />
            );

            sportEventRows.push(component);

            prevMatchId = matchId.match(/visibility/) ? prevMatchId : matchId;
        });

        sportEventRows.push(<StreamStub />);

        return sportEventRows;
    }
}

export default ResultsMatchList;
